import instanceQuery from 'graphql/queries/product/EdataConfigQuery.graphql';
import defaultQuery from 'graphql/queries/product/EdataConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/product/EdataConfigMutation.graphql';
import fragment from 'graphql/fragments/product/EdataConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const EdataConfig = {
  type: 'EdataConfig',
  title: 'EData Configuration',
  formTitle: 'EData Configuration',
  formUrl: '/Products/Edata/EdataConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'EDATA_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default EdataConfig;
